import { Component, Prop } from '@stencil/core';

@Component({
  tag: 'cwru-typography',
  styleUrl: 'typography.css',
  shadow: true,
})

export class TypeStyles {
  @Prop() headingOne: string;
  @Prop() headingTwo: string;
  @Prop() headingThree: string;
  @Prop() headingFour: string;
  @Prop() headingFive: string;
  @Prop() headingSix: string;
  @Prop() defaultContent: string;
  @Prop() defaultLink: string;
  @Prop() blockquote: string;
}
